import { useEffect } from 'react';

interface GTMRootScriptProps {
	GTMId: string;
}

const LOADER_ID = 'gtm-loader';

export function GTMRootScript({ GTMId }: GTMRootScriptProps) {
	const useGTM = !!GTMId?.length;

	useEffect(() => {
		if (!useGTM) return;
		if (document.getElementById(LOADER_ID)) return;
		const script = document.createElement('script');
		script.id = LOADER_ID;
		script.async = true;
		script.src = `https://www.googletagmanager.com/gtm.js?id=${GTMId}`;
		document.head.appendChild(script);
	}, [useGTM, GTMId]);

	return useGTM ? (
		<script
			id="gtm-init"
			dangerouslySetInnerHTML={{
				__html: `
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
				`,
			}}
		/>
	) : null;
}
